module.exports = __webpack_public_path__ + "img/shape_uploaddata_university_en.dc887593.svg";